import React from 'react'
import Breadcrumbs from '@material-ui/core/Breadcrumbs'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import { Container, Typography } from '@material-ui/core'
import { NavLink } from 'react-router-dom'
import { useStyles } from './Styles'

const BreadCrumb = ({ links, current }) => {
  const classes = useStyles()
  return (
    <>
      <Container maxWidth="xl" className={classes.BreadCrumbContainer}>
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small"/>} aria-label="breadcrumb">
          {!!links && !!links.length && [...new Map(links.map(item => [item.key, item])).values()].map((navLink, index) => (
            <NavLink to={navLink.link} key={navLink.key}>
              {navLink.name}
            </NavLink>
          ))}
          {!!current &&
          <Typography color="textPrimary" className={classes.BreadCrumbActiveLink}>{current}</Typography>
          }
        </Breadcrumbs>
      </Container>
    </>
  )
}

export default BreadCrumb
